import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require(['../pages/Home'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js